import React from 'react';
import './Logo.css';

function Logo({ variant = 'dark', size = 'md' }) {
  const sizeClasses = {
    sm: 'logo-sm',
    md: 'logo-md',
    lg: 'logo-lg'
  };

  const textSizeClasses = {
    sm: 'logo-text-sm',
    md: 'logo-text-md',
    lg: 'logo-text-lg'
  };

  // Logo: White letters, lime green circle with gaps on left/right, navy background
  // Circle forms about 3/4 complete - top and bottom arcs present, gaps on left and right
  return (
    <div className={`logo-container ${sizeClasses[size]}`}>
      <svg 
        viewBox="0 0 120 120" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg" 
        className="logo-svg"
      >
        {/* Navy blue background circle */}
        <circle cx="60" cy="60" r="55" fill="var(--color-trustworthy-navy)" />
        
        {/* Sage green circle - top and bottom arcs with gaps on left and right */}
        {/* Top arc - from top-left gap to top-right gap (about 60% of full circle) */}
        <path 
          d="M 25 25 A 45 45 0 0 1 95 25" 
          stroke="hsl(158, 64%, 42%)" 
          strokeWidth="4" 
          fill="none"
          strokeLinecap="round"
        />
        {/* Bottom arc - from bottom-right gap to bottom-left gap (about 60% of full circle) */}
        <path 
          d="M 95 95 A 45 45 0 0 1 25 95" 
          stroke="hsl(158, 64%, 42%)" 
          strokeWidth="4" 
          fill="none"
          strokeLinecap="round"
        />
      </svg>
      {/* Text - "Within" in white, centered */}
      <span className={`logo-text ${textSizeClasses[size]} logo-text-white`}>
        Within
      </span>
    </div>
  );
}

export default Logo;
